import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import user from './modules/user'
import auth from './modules/auth'
import network from './modules/network'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		global,
		auth,
		user,
		network
	}
})
